/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Body from '../partials/Body';

import styles from '../../../styles/blocks/text.module.scss';

const propTypes = {
    title: PropTypes.string,
    body: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    body: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

function TextBlock({ title, body, className, isContainer, containerClassName }) {
    const themeClassName = useThemeClassName(styles);

    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            {title !== null ? (
                <h2
                    className={classNames([styles.title, 'title'])}
                    dangerouslySetInnerHTML={{ __html: title }}
                />
            ) : null}
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {body !== null ? (
                    <Body className={classNames([styles.body, 'body'])} body={body} />
                ) : null}
            </div>
        </div>
    );
}

TextBlock.propTypes = propTypes;
TextBlock.defaultProps = defaultProps;

export default TextBlock;
